<template>
<!-- 查询服务器  -->
  <div class="container-fluid list">
		<div class="row no-gutters shop">
			<div class="col-lg-12  col-md-12 ">
        <div class="sel" >
          <div role="document">
          <div class="modal-content">
            <div class="modal-body">
                  <form class="form-inline">
                      <div class="form-group">
                        <label for="exampleInputName2" class="lab">分区</label>
                        <select class="form-control" v-model="selected">
                            <option disabled value="">请选择</option>
                            <option v-for="(data,index) in res_data" :key="index" >{{data.fld_server_id}}</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label for="exampleInputName2" class="lab">UserID</label>
                        <input type="text" class="form-control"  placeholder="UserID" v-model="user_id">
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail2" class="lab">RoleID</label>
                        <input type="email" class="form-control"  placeholder="RoleID" v-model="role_id">
                      </div>
                      <div class="form-group ">
                        <label for="exampleInputEmail2" class="lab">角色名</label>
                        <input type="email" class="form-control" placeholder="角色名" v-model="role_name">
                      </div>
                      <button type="button" class="btn btn-default-determine" @click="search_sever(records,page)">查询</button>
                  </form>
                  <table class="table table-hover table-bordered  text-nowrap table-responsive">
                        <thead>
                          <tr>
                            <th v-for="(head,index) in head_data" :key="index">
                               <!-- :style="{width:th_width[index]+'px'}" -->
                              <div class="td-width">
                                {{head.Comment}}
                                </div>
                              
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(rows,index) in body_data" :key="index">
                            <td v-for="(rows_list,index) in head_data" :key="index" >
                              <!-- :style="{width:th_width[index]+'px'}" -->
                              <div class="td-width"  :title="rows[rows_list.Name]">
                                {{rows[rows_list.Name]}}
                              </div>
                              
                            </td> 
                          </tr>                                
                        </tbody>
                    </table>
              </div>
            </div>
          </div>
        </div>
			</div>
       <!-- 分页 -->
            <div class="col-lg-3 offset-lg-5  col-md-4 total-page footer" v-if="total&&total>1">
                    <div>
                        <i class="fa fa-fast-backward" @click="home_page"></i>
          							<i class="fa fa-backward" @click="previous_page"></i>
                        <span class="page">{{'第'+page+'页'}}</span>
                        <span class="page">{{'共'+total+'页'}}</span>
          							<i class="fa fa-forward" @click="next_page"></i>
          							<i class="fa fa-fast-forward" @click="Last_pag"></i>
                    </div>
          			</div>
		</div>
  </div>
</template>
<script>
import tool from '../tool/tool.js'
import api from '../api/index.js'
export default {
  name:'query_role',
  data () {
    return {
      //选择框中数据
      selected: '',
      //user_id
      user_id:'',
      //role_id
      role_id:'',
      //角色名
      role_name:'',
      //区服数据
      res_data:'',
      //表头数据
      head_data:null,
      //表体数据
      body_data:null,
      //页数的累加和累减
      num:1,
      //显示的条数
      records:18,
      //初始显示的页数
      page:1,
      //总页数
      total:null,
      //定义每列的宽度
      th_width:[],
      userInfo:window.sessionStorage.getItem('userInfo')
    }
  },
  props: {
    ppr_action:String,
    ppr_action_param:String,
    sle_zone:String
  },
  watch:{
    sle_zone(n,o){
      if(this.body_data){
        this.search_sever(this.records,1)
      }
    }
  },
  created () {
    this.regional_service_data()
    setTimeout(() =>{
      this.search_sever(this.records,1)
    },500)
  },
  mounted () {
    this.show_records()
  },
  methods: {
    //更新时区
			update_timezone(fields,res){
				//更新时区
				if(res!=undefined){
					this.project_data = res.data;
					// this.total=res.data.total;
						fields.map((ite,index,arr)=>{
							if(ite.FieldType=="datetime"||ite.FieldType=="timestamp"){
								 res.forEach((item,index)=>{
									item[ite.Name]=tool.datetime2zone_x(item[ite.Name],this.sle_zone);
								})
							}
						});
					this.body_data = res;
					
				};
			},
    //动态计算显示的条数
    show_records(){
      this.records=parseInt((window.screen.height-350)/43-1);
    },
    //请求区服数据
    async regional_service_data(){
      let res=await tool.async_error(api.regional_service_data('/bin/Sandbox/Launcher/tbl_server/datas',{userInfo:this.userInfo}) )
      this.res_data=res.data;
      this.selected=this.res_data[0].fld_server_id
    },
    //取消按钮
    //  cancel(){
    //      this.selected='';
    //  },
     //查询列表、
     async search_sever(records,page){
       if(this.selected){
         let time=new Date().getTime();        
         let parameter={_search: true,nd: time,rows: records,page: page,sidx: 'fld_record_id',sord: 'desc',searchField: '',searchString: '',searchOper: ''};
         parameter.filters={groupOp:'OR',rules:[]};
         if(this.user_id){
           var user_id_obj={field:'fld_user_id',op:'cn',data:this.user_id};
           parameter.filters.rules.push(user_id_obj)
         }
         if(this.role_id){
           var role_id_obj={field:'fld_role_id',op:'cn',data:this.role_id};
           parameter.filters.rules.push(role_id_obj)
         }
         if(this.role_name){
           var role_name_obj={field:'fld_role_name',op:'cn',data:this.role_name};
           parameter.filters.rules.push(role_name_obj)
         }
         parameter.filters=JSON.stringify(parameter.filters)
         parameter.userInfo=window.sessionStorage.getItem('userInfo');
        if(this.user_id||this.role_id||this.role_name){//根据查询字段渲染数据
          let url='http://152.136.167.127:8000/bin/Sandbox/Sandbox'
          let url1='http://121.36.101.30:19210/bin/Sandbox/Sandbox'
          let url2='http://47.241.50.114:19112/bin/Sandbox/Sandbox'
          if(this.selected==1000||this.selected==1001||this.selected==1002){ 
            let res=await tool.async_error(api.search_sever(url1+this.selected+'/tbl_roles/columns',{userInfo:this.userInfo}))
            this.head_data=res.data.FIELDS;
            var res2=await tool.async_error(api.search_sever_body(url1+this.selected+'/tbl_roles/jqgrid_oper/load',parameter))  
            this.body_data=res2.data.rows;
            this.total=Math.floor(Number(res2.data.total));
            this.page=res2.data.page; 
          }else if(this.selected>=0&&this.selected<100){
            let res=await tool.async_error(api.search_sever(url2+this.selected+'/tbl_roles/columns',{userInfo:this.userInfo}))
            this.head_data=res.data.FIELDS;
            var res3=await tool.async_error(api.search_sever_body(url2+this.selected+'/tbl_roles/jqgrid_oper/load',parameter))  
            this.body_data=res3.data.rows;
            this.total=Math.floor(Number(res3.data.total));
            this.page=res3.data.page;
          }else{
            let res=await tool.async_error(api.search_sever(url+this.selected+'/tbl_roles/columns',{userInfo:this.userInfo}))
            this.head_data=res.data.FIELDS;
            let res1=await tool.async_error(api.search_sever_body(url+this.selected+'/tbl_roles/jqgrid_oper/load',parameter))
            this.body_data=res1.data.rows;
            this.total=Math.floor(Number(res1.data.total));
            this.page=res1.data.page;
          } 
          this.update_timezone(this.head_data,this.body_data);
          this.th_width=tool.calculated_width(this.head_data)
        }
        if(!this.user_id&&!this.role_id&&!this.role_name){//没有查询字段渲染所有的数据
          let parameter={_search: false,nd: time,rows: records,page: page,sidx: 'fld_record_id',sord: 'desc',searchField: '',searchString: '',searchOper: ''};
          parameter.userInfo=window.sessionStorage.getItem('userInfo');
          let url='http://152.136.167.127:8000/bin/Sandbox/Sandbox'
          let url1='http://121.36.101.30:19210/bin/Sandbox/Sandbox'  
          let url2='http://47.241.50.114:19112/bin/Sandbox/Sandbox'
          if(this.selected==1000||this.selected==1001||this.selected==1002){
            let res=await tool.async_error(api.search_sever(url1+this.selected+'/tbl_roles/columns',{userInfo:this.userInfo}))
            this.head_data=res.data.FIELDS;
            var res2=await tool.async_error(api.search_sever_body(url1+this.selected+'/tbl_roles/jqgrid_oper/load',parameter))  
            this.body_data=res2.data.rows;
            this.total=Math.floor(Number(res2.data.total));
            this.page=res2.data.page;
          }else if(this.selected>=0&&this.selected<100){
            let res=await tool.async_error(api.search_sever(url2+this.selected+'/tbl_roles/columns',{userInfo:this.userInfo}))
            this.head_data=res.data.FIELDS;
            var res3=await tool.async_error(api.search_sever_body(url2+this.selected+'/tbl_roles/jqgrid_oper/load',parameter))  
            this.body_data=res3.data.rows;
            this.total=Math.floor(Number(res3.data.total));
            this.page=res3.data.page;
          }else{
            let res=await tool.async_error(api.search_sever(url+this.selected+'/tbl_roles/columns',{userInfo:this.userInfo}))
            this.head_data=res.data.FIELDS;
            let res1=await tool.async_error(api.search_sever_body(url+this.selected+'/tbl_roles/jqgrid_oper/load',parameter))
            this.body_data=res1.data.rows;
            this.total=Math.floor(Number(res1.data.total));
            this.page=res1.data.page;
          }
          this.update_timezone(this.head_data,this.body_data);
          this.th_width=tool.calculated_width(this.head_data)
        }
       }
       
     },
     confirm(){},
    //关闭按钮
     close(){
         this.$emit('close_project')
     },
     home_page(){
       if(this.page>1){
          this.search_sever(this.records,1)
       }
     },
     previous_page(){
       if(this.page>1){
          this.num-=1;
          this.search_sever(this.records,this.num)
       }
     },
     next_page(){
       if(this.page<this.total){
          this.num+=1;
          this.search_sever(this.records,this.num)
       }
     },
     Last_pag(){
       if(this.page<this.total){
         this.search_sever(this.records,this.total)
       }
     },
  },
  components: {
     
  },
  
}
</script>
<style scoped>
.td-width{
  overflow: hidden;
  text-overflow: ellipsis;
}
td{
  font-size: 12px;
}
.footer{
  margin-top: 10px;
  font-size: 12px;
  /* position: fixed; */
  /* bottom: 5px; */
}
.fa{
  color: #007bff;
  padding: 10px;
  cursor: pointer;
}
.page{
  padding: 10px;
}
.fa-fast-backward{

}
   .modal-content{
     border: none;
   }
   .table{
       margin-top: 10px;
       font-size: 14px;
   }
   .table thead tr{
     color:#007bff;
   }
   .form-control{
       margin-right: 10px;
       width: 140px;
       height: 30px;
       font-size: 13px;
   }
   .lab{
       margin-right: 10px;
   }
   .form-inline{
       font-size: 14px;
   }
  .text{
    margin: 0 auto;
    display: block;
    outline: none;
  }
  .modal-header{
	background:#ebecf0;
	height:40px
	}
  .modal-span{
	font-size:20px;
	margin-top:-14px;
	cursor:pointer
	}
  .shop{
    margin-left: 20px;
  }
  .modal-title{
	line-height:1px
	}
  .btn-default-close{
    color:#007bff;
	font-size:12px;
	border:1px solid #808080;
	padding:4px;
	margin-right: 93%;
    }
  .btn-default-determine{
    color:#007bff;
	font-size:12px;
	border: 1px solid rgb(128, 128, 128);
	padding: 4px;
    }
    .list {
		padding-top: 50px;
		padding-right: 20px;
    z-index:999
	}
</style>